<template>
  <div>
    <div>
      <DropDown class="dealer-table-dropdown" :item="DealerField" :inputType="InputType" :options="DealerTerritoryOptions"
        @dropdown-func="handleSearchResultClick" @edit-type="handleEditInputType" />
      <DataInput class="dealer-table-data-input" :dataInput="searchItem" type="text" @inputValue="handleInputValue" />
    </div>
    <div class="dealer-table-overlay-cont">
      <table class="dealer-table">
        <thead>
          <tr class="dealer-table-header-row">
            <th class="dt-header-text-title" v-for="item in DealerTableHeaders" :key="item.id"
              :class="{ sortable: item.value !== 'active', 'sort-active': sortKey === item.value }"
              @click="item.value !== 'active' && handleSort(item.value)">
              {{ item.title }}
              <span v-if="sortKey === item.value" class="sort-arrow">{{ sortDir === 'asc' ? '▲' : '▼' }}</span>
            </th>
            <th class="dt-header-text-edit">EDIT</th>
            <th class="dt-header-text-del">DELETE</th>
          </tr>
        </thead>
        <tbody>
          <tr class="dealer-table-data-row" v-for="item in DealerItems" :id="'dealer-row-' + item.dealerId">
            <td><input class="dealer-table-data-checkbox" type="checkbox" v-model="item.isActive"
                @input="handleActiveStatus(item)"></td>
            <td>{{ item.name }}</td>
            <td>{{ item.city }}, {{ item.state }}</td>
            <td>{{ territoryManager(item) }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td>
              <img @click="handleEditDealer(item)" class="dealer-table-data-edit-icon"
                :src="require('@/assets/svg/SVG/edit.svg')">
            </td>
            <td>
              <img @click="handleDeleteDealer(item)" class="dealer-table-data-delete-icon"
                :src="require('@/assets/svg/SVG/white_bg_x_gry_stroke.svg')">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <Pagination :total-pages="TotalPages" :current-page="currentPage" @page-change="handlePageChange"></Pagination> -->
  </div>
</template>
<script>
import { useDealerStore } from '@/store/DealerStore';
import { useModalStore } from '@/store/ModalStore';
import Pagination from './Pagination.vue';
import DataInput from './DataInput.vue';
import DropDown from './DropDown.vue';
import gsap from 'gsap';
export default {
  data () {
    return {
      currentPage: 1,
      perPage: 30,
      searchItem: {
        field: 'dealer_search',
        label: 'Dealer Search',
        value: '',
        type: 'text',
        required: false,
      },
      dealers: null,
      savedDealers: null,
      filterField: {
        field: 'dealerName',
        label: 'Filter by Territory Manager',
        placeholder: 'Territory Manager',
        value: '',
        type: 'select',
        required: true,
      },
      dealerTerritories: null,
      removeDealer: null,
      pastDealer: null,
      sortKey: null,
      sortDir: 'asc'
    };
  },
  components: {
    Pagination,
    DataInput,
    DropDown
  },
  computed: {
    Dealers () {
      const dealerStore = useDealerStore();
      this.savedDealers = dealerStore.dealers;
      this.dealers = dealerStore.dealers;
      return dealerStore.dealers;
    },
    DealerField () {
      return this.filterField;
    },
    InputType () {
      return useDealerStore().inputType;
    },
    DealerTerritoryOptions () {
      if (this.dealerTerritories != null) {
        return this.dealerTerritories.map((item) => {
          return {
            id: item.territoryId,
            name: item.manager,
            value: item.territoryId
          };
        });
      }
    },
    DealerTerritories () {
      const dealerStore = useDealerStore();
      this.dealerTerritories = dealerStore.dealerTerritories;
      return dealerStore.dealerTerritories;
    },
    States () {
      const dealerStore = useDealerStore();
      return dealerStore.states;
    },
    Countries () {
      const dealerStore = useDealerStore();
      return dealerStore.countries;
    },
    DealerTableHeaders () {
      const dealerStore = useDealerStore();
      return dealerStore.dealerTableHeaders;
    },
    TotalPages () {
      if (this.Dealers != null) {
        return Math.ceil(this.dealers.length / this.perPage);
      }
    },
    DealerItems () {
      if (this.Dealers != null) {
        const items = [...this.dealers];
        if (this.sortKey) {
          items.sort((a, b) => {
            const aVal = this.getSortValue(a, this.sortKey);
            const bVal = this.getSortValue(b, this.sortKey);
            if (aVal < bVal) {return this.sortDir === 'asc' ? -1 : 1;}
            if (aVal > bVal) {return this.sortDir === 'asc' ? 1 : -1;}
            return 0;
          });
        } else {
          items.sort((a, b) => b.dealerId - a.dealerId);
        }
        return items;
      }
    },
    DealerLevels () {
      const dealerStore = useDealerStore();
      return dealerStore.dealerLevels;
    }
    // PaginatedItems() {
    //   if (this.Dealers != null) {
    //     const startIndex = (this.currentPage - 1) * this.perPage;
    //     const endIndex = startIndex + this.perPage;
    //     return this.dealers.slice(startIndex, endIndex);
    //   }
    // }
  },
  methods: {
    handleSort (key) {
      if (this.sortKey === key) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortDir = 'asc';
      }
    },
    getSortValue (item, key) {
      if (key === 'dealerName') {return (item.name ?? '').toLowerCase();}
      if (key === 'location') {return (item.city ?? '').toLowerCase();}
      if (key === 'territoryMgr') {return (this.territoryManager(item) ?? '').toLowerCase();}
      if (key === 'phoneNumber') {return (item.phone ?? '').toLowerCase();}
      return (item[key] ?? '').toString().toLowerCase();
    },
    handleEditInputType (input) {
      useDealerStore().inputType = input;
    },
    handleActiveStatus (item) {
      const dealerStore = useDealerStore();
      item.isActive = item.isActive === true ? false : true;
      dealerStore.submitActiveStatus(item);
    },
    handleSearchResultClick (product) {
      this.selectedProduct = product;
      this.filterField.value = product;
      if (product === null) {
        this.dealers = this.Dealers;
      } else {
        this.dealers = this.Dealers.filter((item) => item.territoryId === product.id);
        this.savedDealers = this.dealers;
      }
    },
    handleInputValue (item) {
      let searchTxt = item.value.toLowerCase();
      // get the matching products
      this.dealers = this.savedDealers.filter((product) => {
        return product.name.toLowerCase().includes(searchTxt);
      });
    },
    territoryManager (item) {
      if (this.DealerTerritories != null) {
        const territoryMgr = this.DealerTerritories.find((el) => el.territoryId === item.territoryId);
        return territoryMgr.manager;
      }
    },
    handleEditDealer (item) {
      const dealerStore = useDealerStore();
      dealerStore.setSelectedDealer(item);
      dealerStore.mode = 'edit';
      if (item != this.pastDealer) {
        if (this.pastDealer != null) {
          gsap.to('#dealer-row-' + this.pastDealer.dealerId, {
            backgroundColor: '#FFFFFF'
          });
        }
      }
      gsap.to('#dealer-row-' + item.dealerId, {
        backgroundColor: '#D3d3d3'
      });
      // fill inputs
      dealerStore.dealerInputs.forEach((type) => {
        if (type.field === 'territory') {
          const territory = this.DealerTerritories.find((el) => el.territoryId === item.territoryId);
          type.value = {
            id: territory.territoryId,
            name: territory.manager + ': ' + territory.territory,
            value: territory.territoryId
          };
        } else if (type.field === 'state') {
          const state = this.States.find((el) => el.abbreviation == item.state);
          type.value = state;
        } else if (type.field === 'country') {
          const currState = this.States.find((el) => el.abbreviation == item.state);
          const countryId = currState.countryId;
          const country = this.Countries.find((el) => el.countryId === countryId);
          type.value = country;
        } else if (type.field === 'dealerLevel') {
          const dealerLevel = this.DealerLevels.find((el) => el.dealerLevelId === item.dealerLevelId);
          type.value = dealerLevel;
        } else {
          type.value = item[type.field];
        }
        dealerStore.currentDealer = item;
        this.pastDealer = item;
      });
      // const modalStore = useModalStore();
      // modalStore.showModal('edit');
      // modalStore.setModalObj(item);
    },
    handleDeleteDealer (item) {
      this.removeDealer = item;
      const modalStore = useModalStore();
      modalStore.showModal('prompt');
      modalStore.setModalObj({
        promptLabel: 'Remove ' + item.name,
        promptDescription: 'Are you sure you want to remove this dealer?',
        buttonALabel: 'Delete',
        buttonAFunc: this.handleDelete,
        buttonBLabel: 'Cancel',
        buttonBFunc: this.handleCancel,
      });
    },
    handleDelete () {
      const dealerStore = useDealerStore();
      dealerStore.removeDealer(this.removeDealer.dealerId);
      this.removeDealer = null;
    },
    handleCancel () {
      useModalStore().hideModal();
    },
    handlePageChange (page) {
      this.currentPage = page;
    }
  }
};
</script>
<style scoped>
.dealer-table-overlay-cont {
  max-height: 600px;
  overflow-y: auto;
}

th {
  font-size: 13px;
  font-weight: 550;
}

.dealer-table {
  table-layout: fixed;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.dealer-table-header-row {
  top: 0;
  background-color: #fafafa;
  border-collapse: separate;
  position: sticky;
  width: 100%;
}

.dealer-table-data-row {
  text-align: center;
  vertical-align: middle;
  font-size: small;
}

.dealer-table-data-row:hover {
  background-color: lightgray;
}

.dealer-table-data-edit-icon {
  cursor: pointer;
  width: 20px;
}

.dealer-table-data-delete-icon {
  cursor: pointer;
  width: 20px;
}
.dealer-table-data-checkbox {
  width:16px;
  height: 16px;
  cursor: pointer;
}
th, td {
  padding: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* col 1: active, 2: name, 3: location, 4: territory mgr, 5: email, 6: phone, 7: edit, 8: delete */
th:nth-child(1), td:nth-child(1) { width: 5%; }
th:nth-child(2), td:nth-child(2) { width: 18%; }
th:nth-child(3), td:nth-child(3) { width: 12%; }
th:nth-child(4), td:nth-child(4) { width: 14%; }
th:nth-child(5), td:nth-child(5) { width: 22%; }
th:nth-child(6), td:nth-child(6) { width: 14%; }
th:nth-child(7), td:nth-child(7) { width: 5%; }
th:nth-child(8), td:nth-child(8) { width: 5%; }
.dealer-table-dropdown {
  max-width: 440px;
}
.dealer-table-data-input {
  max-width: 700px;
}
.sortable {
  cursor: pointer;
  user-select: none;
}
.sortable:hover {
  background-color: #efefef;
}
.sort-active {
  background-color: #e8e8e8;
}
.sort-arrow {
  font-size: 10px;
  margin-left: 4px;
}
</style>